import { createFileRoute } from '@tanstack/react-router';

import { PlatformClientListScreen } from '@/features/clients/components/platform/ClientListScreen';
import { requirePermission } from '@/lib/guards';

export const Route = createFileRoute('/_staff/admin/platform/clients/')({
  beforeLoad: () => {
    requirePermission('client:read');
  },
  component: PlatformClientListScreen,
  staticData: { crumb: 'Clients' },
});
